function initGhostGleamSlider() {
  const containers = document.querySelectorAll('.carousel-container');
  if (!containers.length) return;

  containers.forEach(function (container) {
    // Agar pehle se initialized hai to skip
    if (container.classList.contains('flickity-enabled')) return;

    const timerAttr = container.getAttribute('data-autoplay');
    const timer = parseInt(timerAttr, 10) * 1000;

    new Flickity(container, {
      cellAlign: 'left',
      contain: true,
      pageDots: false,
      prevNextButtons: false,
      autoPlay: timer > 0 ? timer : false,
      wrapAround: true,
      groupCells: 1,
      resize: true,
      imagesLoaded: true,    // FIX: image fully load hone ke baad hi size/position calculate karega
      percentPosition: true  // explicit: %-based cell widths (25%/50%) ke sath consistent rahega
    });
  });
}

// 1. Standard Page Load
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initGhostGleamSlider);
} else {
  initGhostGleamSlider();
}

// 2. Shopify Theme Editor Reload Fix (Jab customizer mein settings change hon)
document.addEventListener('shopify:section:load', function (e) {
  initGhostGleamSlider();
});